import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { FeedbackAction } from "../actions";
import * as FeedbackApi from "../api/feedback";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherFeedback() {
  yield takeLatest(types.FEEDBACK_LIST_REQUEST, list);
  yield takeLatest(types.FEEDBACK_SCORE_REQUEST, score);
  yield takeLatest(types.FEEDBACK_TITLES_REQUEST, titles);
  yield takeLatest(types.FEEDBACK_STORE_REQUEST, store);
  yield takeLatest(types.FEEDBACK_READ_REQUEST, read);
  yield takeLatest(types.FEEDBACK_SHOW_REQUEST, get);
}

function getList() {
  return FeedbackApi.getList();
}

function* list() {
  try {
    const response = yield call(getList);
    yield put(FeedbackAction.getListSuccess(response.data.data));
  } catch (error) {
    yield put(FeedbackAction.getListFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function scoreReq(id, score) {
  return FeedbackApi.score(id, score);
}

function* score(action) {
  try {
    yield call(scoreReq, action.id, action.score);
    yield put(
      FeedbackAction.ScoreSuccess({ id: action.id, score: action.score })
    );
  } catch (error) {
    yield put(FeedbackAction.ScoreFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function titlesReq() {
  return FeedbackApi.getTitles();
}

function* titles() {
  try {
    const response = yield call(titlesReq);
    yield put(FeedbackAction.titlesSuccess(response.data.data));
  } catch (error) {
    yield put(FeedbackAction.titlesFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function storeReq(data) {
  return FeedbackApi.store(data);
}
async function storeImageReq(file, id) {
  return FeedbackApi.storeImage(file, id);
}
function* store(action) {
  try {
    const response = yield call(storeReq, action.data);
    yield put(FeedbackAction.storeSuccess(response.data.data));
    toastr.error(" ", "با تشکر. بازخورد شما ارسال شد");
    for (let i = 0; i < action.data.files.length; i++) {
      yield call(storeImageReq, action.data.files[i], response.data.data.id);
    }
    yield put(FeedbackAction.getListRequest());
  } catch (error) {
    yield put(FeedbackAction.storeFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function readReq(id) {
  return FeedbackApi.read(id);
}

function* read(action) {
  try {
    yield call(readReq, action.id);
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function getReq(id) {
  return FeedbackApi.get(id);
}

function* get(action) {
  try {
    const response = yield call(getReq, action.id);
    yield put(FeedbackAction.getSuccess(action.id, response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(FeedbackAction.getFailure(action.id, error));
  }
}
